import { render, staticRenderFns } from "./coursDashLocal.vue?vue&type=template&id=7e72c656&"
import script from "./coursDashLocal.vue?vue&type=script&lang=js&"
export * from "./coursDashLocal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports